module.exports = __webpack_public_path__ + "build/desktop/a/img/confirm.93ea2efec6f411b8870f13e90bf2362f.svg";